import { API } from "config";
import type { ChatThread } from "types/ChatThread";
import request from "utilities/request";

const baseUrl = API.dbApi.url;

/**
 * Partial update for a chat thread's metadata.
 */
export interface PatchThreadInput {
  name?: string;
  personaId?: ChatThread["personaId"];
  timestamp?: string;
}

/**
 * Updates a chat thread's metadata.
 * Returns the updated thread.
 */
export async function patchThread(
  threadId: string,
  patch: PatchThreadInput,
  getAccessToken: () => Promise<string>
): Promise<ChatThread> {
  const accessToken = await getAccessToken();

  const url = `${baseUrl}/threads/${threadId}`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
  };
  const options = {
    method: "PATCH",
    headers,
    body: JSON.stringify(patch),
  };

  const response = await request(url, options);
  return (await response.json()) as ChatThread;
}
